import { useModal } from '@ebay/nice-modal-react';
import { Stack } from '@mui/material';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { Button, Typography, SizingMultiplier } from '@ocx/ui';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ModalDrawer } from '@ocx/ui-modals';

import { messages } from './inactive-phone-number-warning-popup.messages';

type InactivePhoneNumberWarningPopupProps = {
  onCancel?: () => void;
};

export const InactivePhoneNumberWarningPopupController = ({ onCancel }: InactivePhoneNumberWarningPopupProps) => {
  const { visible, hide, remove } = useModal();

  const onCancelHandler = useCallback(() => {
    onCancel?.();
    hide();
  }, [hide, onCancel]);

  return (
    <ModalDrawer open={visible} onClose={onCancelHandler} onExited={remove}>
      <Stack spacing={SizingMultiplier.lg} p={SizingMultiplier.lg} pt={SizingMultiplier.xl}>
        <Stack spacing={SizingMultiplier.md}>
          <Typography variant="h5" component="h1">
            <FormattedMessage {...messages['inactive-phone-number-warning:popup-title']} />
          </Typography>
          <Typography>
            <FormattedMessage {...messages['inactive-phone-number-warning:popup-description']} />
          </Typography>
        </Stack>
        <Stack spacing={SizingMultiplier.sm}>
          <Button onClick={onCancelHandler} variant="contained">
            <FormattedMessage {...buttonTextMessages['button-text:dismiss']} />
          </Button>
        </Stack>
      </Stack>
    </ModalDrawer>
  );
};
